import { render } from "./NameChange.vue?vue&type=template&id=dec91ae0&scoped=true"
import script from "./NameChange.vue?vue&type=script&lang=js"
export * from "./NameChange.vue?vue&type=script&lang=js"

import "./NameChange.vue?vue&type=style&index=0&id=dec91ae0&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec91ae0"]])

export default __exports__